import { useContentController_getSanityContent } from '@/services/hooks';
import type { CustomerBannerMessage } from '@/services/types';

/** The banner messages editors publish in the CMS; empty until the content has loaded. */
export function useGetCustomerBannerMessages(): CustomerBannerMessage[] {
    const { data, isSuccess } = useContentController_getSanityContent();
    return (isSuccess && data?.data?.customerBannerMessages) || [];
}
